import ShopBasketResourceModel from '../../generated/types/model/resource/ShopBasketResourceModel';

export default class ShopBasketResourceViewModel extends ShopBasketResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
